import * as d3 from 'd3'
export default {
  methods: {

    draw_Header() {
      

      let table = this.canvasForm
      .append('g')
      .attr('transform', `translate(${this.table.x}, 0)`)

      if(this.title.display == 'Y') {
        table
        .append('text')
        .attr('transform', `translate(0, 20)`)
        .attr('font-size', 14).attr('fill', '#000')
        .text(this.sql1.MAIN)

        table
        .append('text')
        .attr('transform', `translate(0, 33)`)
        .attr('font-size', 11).attr('fill', '#757575')
        .text(this.sql1.SUB)
      }


      // Header
      let head = table
      .append('g')
      .attr('transform', `translate(0, ${this.table.y})`)

      this.columns.forEach((d,i)=> {
        if(d.group && d.group != 'L') {
          head
          .append('text')
          .attr('x', d.mx).attr('y', 17 + 11*0.35)
          .attr('font-size', 11).attr('fill', '#333')
          .attr('text-anchor', 'middle')
          .text(d.group)
        }
        if(i>1) {
          head
          .append('text')
          .attr('x', d.mx).attr('y', 37 + 9*0.35)
          .attr('font-size', 9).attr('fill', '#333')
          .attr('text-anchor', 'middle')
          .text(d.name)
        } else {
          head
          .append('text')
          .attr('x', d.mx).attr('y', 26 + 11*0.35)
          .attr('font-size', 11).attr('fill', d.code == 'SUBSYS' ? '#44A9DF' : '#333')
          .attr('text-anchor', 'middle')
          .text(d.name)
        }
        if(d.group =='L') this.gmx_Line(head, d.ex, d.ex, 5,  247,  '#E0E0DF', .5, 1)
      })

      head
      .append('text')
      .attr('x', this.columns[2].ex).attr('y', 17 + 11*0.35)
      .attr('font-size', 11).attr('fill', '#333')
      .attr('text-anchor', 'middle')
      .text('MCC DATE')

      this.gmx_Line(head, this.columns[1].ex, this.table.width, 28,  28,  '#E0E0DF', .5, 1)
      this.gmx_Line(head, 0, this.table.width, 6,  6,  '#bcbcbc', .5, 1)
      this.gmx_Line(head, 0, this.table.width, 47, 47, '#bcbcbc', .5, 1)
      this.gmx_Line(head, 0, this.table.width, 247, 247, '#bcbcbc', .5, 1)



    },


  }
}